export default {
  'meta': {
    'langName': 'GREEK',
    'lang': 'Ελληνικά'
  },
  'title': 'ΑΝΑΚΛΗΣΗ ΠΡΟΪΟΝΤΟΣ ΜΠΑΣΚΕΤΑ B900 BOX NBA TARMAK',
  'description': 'Γειά σας,\n\n\nΑγοράσατε πρόσφατα μία μπασκέτα Tarmak B900 BOX NBA και σας ευχαριστούμε για την αγορά σας.\n\nΩς μέρος της συνεχούς δέσμευσής μας για την ποιότητα και την ασφάλεια των προϊόντων, η ομάδα μπάσκετ DECATHLON εντόπισε έναν πιθανό κίνδυνο κατακόρυφης πτώσης του στύλου εάν αφαιρεθεί η μανιβέλα ρύθμισης ύψους και στη συνέχεια χειριστεί ή χρησιμοποιηθεί το προϊόν.\n\nΣας παρακαλούμε να απαντήσετε σε μερικές ερωτήσεις, ώστε να σας παρέχουμε την κατάλληλη λύση ασφαλείας για το προϊόν σας.\n\nΖητούμε συγγνώμη για την αναστάτωση και σας ευχαριστούμε για την εμπιστοσύνη σας.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Αρχικά, μπορείτε να επιβεβαιώσετε τη διεύθυνση email και τη χώρα διαμονής σας:\r'
  },
  'fields': {
    'country': 'Χώρα',
    'address': 'Διεύθυνση email',
    'email': 'Διεύθυνση email',
    'phonePrefix': 'Κωδικός αριθμού τηλεφώνου',
    'phone': 'Αριθμός τηλεφώνου',
    'validations': {
      'phoneOrEmail': 'Παρακαλούμε εισάγετε τουλάχιστον μια διεύθυνση email ή έναν αριθμό τηλεφώνου.',
      'email': 'Εισαγάγετε μια έγκυρη διεύθυνση email',
      'phone': 'Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνου'
    },
    'firstName': 'Επώνυμο',
    'lastName': 'Ονομα',
    'deliveryAddress': 'Διεύθυνση αποστολής για το πακέτο',
    'additionalAddress': 'Πρόσθετες λεπτομέρειες διεύθυνσης',
    'city': 'Πόλη',
    'zip': 'Ταχυδρομικός Κώδικας',
    'choose': 'Επιλογή',
    'required': 'Αυτό το πεδίο είναι υποχρεωτικό'
  },
  'ownerCheck': {
    'title': 'Έχετε ακόμα μία ή περισσότερες μπασκέτες B900 BOX NBA;\n'
  },
  'yes': 'ΝΑΙ',
  'no': 'ΟΧΙ',
  'ownerChanged': {
    'title': 'Έχετε τα στοιχεία επικοινωνίας του τρέχοντος κατόχου;',
    'confirmation': 'Κύριε/Κυρία,\n\nΣας ευχαριστούμε για τη συμμετοχή σας σε αυτήν την ενέργεια ποιότητας.\n\nΖητούμε συγγνώμη για την αναστάτωση και σας ευχαριστούμε για την εμπιστοσύνη σας.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Σημειώστε τον αριθμό των μπaσκετών που έχετε, με βάση τον τύπο της μανιβέλας που έχει τοποθετηθεί',
    'descriptionRed': 'Μπασκέτα με αφαιρούμενη κόκκινη μανιβέλα',
    'descriptionBlack': 'Μπασκέτα με σταθερή μαύρη μανιβέλα',
    'quantity': 'Ποσότητα',
    'notConcerned': 'Ο κύριος/κα,\n\nΣας ευχαριστούμε για τη συμμετοχή σας σε αυτήν την ενέργεια ποιότητας.\n\nΜπορείτε να είστε σίγουροι ότι η μπασκέτα Tarmak B900 BOX NBA δεν επηρεάζεται από τη διαδικασία ανάκλησης. Είναι ασφαλής στη χρήση.\n\nΖητούμε συγγνώμη για την όποια ταλαιπωρία και σας ευχαριστούμε για την εμπιστοσύνη σας.\n\nDECATHLON',
    'concernedProductQuantity': 'Μη συμμορφούμενη ποσότητα προϊόντος:',
    'concernedProductLabel': 'Μη συμμορφούμενο προϊόν:',
    'confirmation': 'Σας ευχαριστούμε για τη συμπλήρωση αυτής της φόρμας. Το αίτημά σας καταγράφηκε με επιτυχία.\n\nΘα σας στείλουμε τον αριθμό παρακολούθησης για την παράδοση του κιτ σας το συντομότερο δυνατό.\n\nΣας ευχόμαστε μια υπέροχη μέρα.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Επισκευή με τη συμμετοχή σας',
    'description': 'Διαπιστώσαμε κίνδυνο πτώσης του στύλου κατακόρυφα εάν αφαιρεθεί η μανιβέλα και το χειριστείτε ή χρησιμοποιήσετε το προϊόν σε ορισμένες μπασκέτες TARMAK B900 BOX NBA, κωδ. 4239136.\nΜε βάση την απάντησή σας, το προϊόν σας φαίνεται να επηρεάζεται από αυτόν τον κίνδυνο.\n\nΩς εκ τούτου, σας ζητάμε να σταματήσετε να το χρησιμοποιείτε αμέσως και προσφέρουμε να σας βοηθήσουμε στην προσαρμογή της μανιβέλας, ώστε να μπορείτε να χρησιμοποιείτε το προϊόν σας με ασφάλεια.\nΝα είστε βέβαιοι ότι αυτή η επισκευή δεν απαιτεί ιδιαίτερη τεχνογνωσία—όλα εξηγούνται ξεκάθαρα στο βίντεο και στο εγχειρίδιο οδηγιών παρακάτω:',
    'videoLink': 'Σύνδεσμος βίντεο',
    'docLink': 'Σύνδεσμος οδηγιών',
    'callToAction': 'Κάντε κλικ εδώ για να λάβετε το δωρεάν κιτ επισκευής σας',
    'warranty': 'Η όλη διαδικασία καλύπτεται από την 5ετή μας εγγύηση.'
  },
  'repairRequest': {
    'title': 'Εισάγετε τις παρακάτω πληροφορίες, ώστε το δωρεάν κιτ σας να σταλεί στη διεύθυνση της επιλογής σας:'
  },
  'form': {
    'submit': 'Επόμενο'
  },
  'status': 'Translation validated by COUNTRY'
} as const
